import { render, staticRenderFns } from "./DataStoryCard.vue?vue&type=template&id=977ca980&scoped=true&"
import script from "./DataStoryCard.vue?vue&type=script&lang=js&"
export * from "./DataStoryCard.vue?vue&type=script&lang=js&"
import style0 from "./DataStoryCard.vue?vue&type=style&index=0&id=977ca980&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977ca980",
  null
  
)

export default component.exports